import {
    createFilterParameter,
    createFilterCheckboxItem,
    handleCategoryFilters,
    handleBrandsFilters
} from '~/themes/novaporta/types/filters';

const theState = {
    filtersData: null,
    filters: [],
    priceRange: [],
    isRangeSliderTriggered: false,
    isFiltersInit: false, // Purpose of flag is to understand if filters data have been registried in store

    activeSortingOption: null,
    sortingOptions: [
        {
            name: 'sortingOptionsPopularName', // This is a key of i18n plugin, if you wanna change the translation refactoring the key in /locales directory
            keyword: 'sort_priority-'
        },
        {
            name: 'sortingOptionsPopularPrice', // This is a key of i18n plugin, if you wanna change the translation refactoring the key in /locales directory
            keyword: 'price+'
        }
    ]
};

const store = {
    namespaced: true,
    state() {
        return theState;
    },
    getters: {
        getFilters: state => state.filters,
        getPriceRange: state => state.priceRange,
        getPriceRangeLimits: state => {
            return {
                from: Number(state.filtersData?.default_min) || null,
                to: Number(state.filtersData?.default_max) || null
            };
        },
        getQueryFilters: state => {
            let handledFilters = [];
            const priceFrom = state.priceRange[0] || null;
            const priceTo = state.priceRange[1] || null;
            if (priceFrom && priceTo && state.isRangeSliderTriggered) {
                handledFilters.push({ price: [priceFrom, priceTo] });
            }

            // Certain active parameters
            state.filters.filter(f => {
                const activeOptions = f.options.filter(o => o.active === true) || [];
                const activeOptionsKeywords = activeOptions.map(o => o.id);

                if (activeOptions.length) {
                    handledFilters.push({
                        [f.id]: activeOptionsKeywords
                    });
                }
            });

            if (handledFilters.length) return handledFilters;
            else return undefined; // undefined value is required for correct end-point working
        },
        getIsFiltersInit: state => state.isFiltersInit,
        getSortingOptions: state => state.sortingOptions,
        getActiveSortingOption: (state, getters, rootState, rootGetters) => {
            const defaultSortingByPriority = rootGetters['global/getDefaultSortByPriority'];

            if (state.activeSortingOption) {
                return state.activeSortingOption;
            }

            return defaultSortingByPriority ? 'sort_priority-' : null;
        },
        getIsFiltersEmpty: state => {
            const priceFrom = Number(state.filtersData?.default_min) || null;
            const priceTo = Number(state.filtersData?.default_max) || null;

            if (!state.filters.length && priceFrom === null && priceTo === null) return true;
            else return false;
        },
        getIsRangeSliderTriggered: state => state.isRangeSliderTriggered
    },
    mutations: {
        CLEAR_STATE: (state, _) => {
            Object.keys(state).forEach(key => {
                state[key] = theState[key];
            });
        },

        SET_FILTERS(state, filters) {
            state.filters = filters;
        },
        SET_FILTER_DATA(state, filters) {
            state.filtersData = filters;
        },
        SET_PRICE_RANGE(state, range) {
            state.priceRange = range;
        },
        SET_IS_FILTER_INIT(state, flag) {
            state.isFiltersInit = flag;
        },
        SET_ACTIVE_SORTING_OPTION(state, keyword) {
            state.activeSortingOption = keyword;
        },
        SET_IS_RANGE_SLIDER_TRIGGERED(state, flag) {
            state.isRangeSliderTriggered = flag;
        },
        SET_FILTERS_FROM_QUERY: (state, updatedFilters) => {
            state.filters = updatedFilters;
        }
    },
    actions: {
        clearState: ({ commit }) => commit('CLEAR_STATE'),

        setFiltersData: ({ commit, state }, data) => {
            const handleParamValueActiveField = (filters, optionKeyword, valueKeyword) => {
                let matchedValue = false;
                if (filters?.length) {
                    state.filters.filter(f => {
                        if (f.keyword === optionKeyword) {
                            f.options.filter(o => {
                                if (o.keyword === valueKeyword) matchedValue = o.active;
                            });
                        }
                    });
                    return matchedValue;
                } else return false;
            };
            let handledFilters = [];
            let brandsFilters = [];

            if (data?.filters?.optionsValues?.length) {
                handledFilters = data.filters.optionsValues?.map(f => {
                    return createFilterParameter({
                        id: f.id,
                        title: f.name,
                        keyword: f.sp_key,
                        options: f.options.map(o => {
                            return createFilterCheckboxItem({
                                id: o.id,
                                title: o.name,
                                keyword: o.sp_key,
                                active: handleParamValueActiveField(state.filters, f.sp_key, o.sp_key)
                            });
                        }),
                        type: 'checkbox' // Have to make dynamic
                    });
                });
            }

            if (data?.filters?.category_filters?.length) {
                // handledFilters = null;
                const categoryFilters = handleCategoryFilters(data?.filters?.category_filters);
                handledFilters = categoryFilters?.map(f => {
                    return createFilterParameter({
                        id: f.id,
                        title: f.title,
                        keyword: f.sp_key,
                        options: f.options.map(o => {
                            return createFilterCheckboxItem({
                                id: o.id,
                                title: o.title,
                                keyword: o.sp_key,
                                active: handleParamValueActiveField(state.filters, f.sp_key, o.sp_key)
                            });
                        }),
                        type: 'checkbox' // Have to make dynamic
                    });
                });
            }

            if (data?.filters?.brands?.length) {
                const brandsFiltersFormatted = handleBrandsFilters(data?.filters?.brands);
                brandsFilters = brandsFiltersFormatted?.map(f => {
                    return createFilterParameter({
                        id: f.id,
                        title: f.title,
                        keyword: f.sp_key,
                        options: f.options.map(o => {
                            return createFilterCheckboxItem({
                                id: o.id,
                                title: o.title,
                                keyword: o.sp_key,
                                active: handleParamValueActiveField(state.filters, f.sp_key, o.sp_key)
                            });
                        }),
                        type: 'checkbox' // Have to make dynamic
                    });
                });
                handledFilters = [...brandsFilters, ...handledFilters];
            }

            // handledFilters = handledFilters.filter((item, idx, arr) => arr.findIndex(el => el.keyword === item.keyword) === idx); // Filter duplicates by keyword field
            commit('SET_FILTERS', handledFilters);

            if (!state.isFiltersInit && data.filters?.min_and_max_price_value) {
                const valueFrom = Number(data.filters.min_and_max_price_value.from) || 0;
                const valueTo = Number(data.filters.min_and_max_price_value.to) || 0;
                if (valueFrom || valueTo) commit('SET_PRICE_RANGE', [valueFrom, valueTo]);
            }
            commit('SET_FILTER_DATA', data);
            commit('SET_IS_FILTER_INIT', true);
        },
        setFilters: ({ commit }, filters) => commit('SET_FILTERS', filters),
        setPriceRange: ({ commit }, range) => {
            commit('SET_PRICE_RANGE', range);
            commit('SET_IS_RANGE_SLIDER_TRIGGERED', true);
        },
        setFilterParamValueActive: ({ commit, state }, settings) => {
            const condition = 'flag' in settings && 'keyword' in settings && 'optionKeyword' in settings;
            let newFilters = state.filters;

            if (condition) {
                const flagOptionValue = (argFlag, argKeyword, argOptionKeyword) => {
                    if (settings.keyword === argKeyword && settings.optionKeyword === argOptionKeyword) return settings.flag;
                    else return argFlag;
                };

                newFilters = newFilters.map(f => {
                    return {
                        ...f,
                        options: f.options.map(o => {
                            return {
                                ...o,
                                active: flagOptionValue(o.active, o.id, f.id)
                            };
                        })
                    };
                });
            }

            commit('SET_FILTERS', newFilters);
        },
        setFiltersFromQuery: ({ commit, state, dispatch }, filtersFromQuery) => {
            if (!filtersFromQuery) {
                dispatch('resetFilters');
                return;
            }

            const filtersArray = [];

            const parts = filtersFromQuery.split(/,(?=[a-zA-Z0-9_]+:)/);

            if (parts) {
                parts.forEach(pair => {
                    // Разделение каждой пары по символу `:`
                    const [key, valuesString] = pair.split(':');
                    if (key && valuesString) {
                        // Преобразование строки значений в массив чисел
                        const values = valuesString.split(',').map(Number);

                        filtersArray.push({
                            id: parseFloat(key) ? parseFloat(key) : key,
                            options: values
                        });
                    }
                });
            }

            // Создаем копию фильтров, чтобы избежать прямой мутации состояния
            const updatedFilters = state.filters.map(filter => {
                // Найти объект с таким же `id`, что и у текущего фильтра

                const matchingFilter = filtersArray.find(
                    item => parseFloat(item.id) === parseFloat(filter.id) || item.id === filter.id
                );

                // Создаем копию filter.options
                const updatedOptions = filter.options.map(option => {
                    if (matchingFilter && matchingFilter.options.includes(option.id)) {
                        return { ...option, active: true };
                    }
                    return { ...option, active: false };
                });

                // Возвращаем обновленный фильтр с обновленными опциями
                return {
                    ...filter,
                    options: updatedOptions
                };
            });

            commit('SET_FILTERS_FROM_QUERY', updatedFilters);
        },
        setActiveSortingOption: ({ commit }, keyword) => commit('SET_ACTIVE_SORTING_OPTION', keyword),
        resetFilters: ({ commit, state }) => {
            const resetedPriceRange = [Number(state.filtersData?.default_min), Number(state.filtersData?.default_max)];

            const resetedFilters = state.filters.map(f => {
                return {
                    ...f,
                    options: f.options.map(o => {
                        return { ...o, active: false };
                    })
                };
            });

            commit('SET_FILTERS', resetedFilters);
            commit('SET_PRICE_RANGE', resetedPriceRange);
        }
    }
};

export default store;
